import React from 'react'
import { Button } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'

type Props = {
  inputRef: React.RefObject<HTMLInputElement>
  loading: boolean
  selectedFile: File | null
  onDrop: (event: React.DragEvent<HTMLDivElement>) => void
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const MsProjectImportStepOne = ({ inputRef, loading, selectedFile, onDrop, onFileChange }: Props) => {
  const { t } = useTranslation()

  if (loading) {
    return (
      <div className="ms-project-importer-processing" role="status">
        <div className="spinner-border text-primary" aria-hidden="true" />
        <strong>{t('MS_PROJECT_IMPORTER:ValidatingFile')}</strong>
        <span>{selectedFile?.name}</span>
      </div>
    )
  }

  return (
    <div
      className="ms-project-importer-drop-area"
      onDragOver={(event) => event.preventDefault()}
      onDrop={onDrop}
    >
      <input
        ref={inputRef}
        data-testid="ms-project-file-input"
        type="file"
        accept=".mpp,.xlsx,.xls"
        className="ms-project-importer-file-input"
        onChange={onFileChange}
      />
      <p>{t('MS_PROJECT_IMPORTER:DropText')}</p>
      <Button variant="outline-secondary" onClick={() => inputRef.current?.click()}>
        {t('MS_PROJECT_IMPORTER:BrowseFiles')}
      </Button>
    </div>
  )
}

export default MsProjectImportStepOne
